import {useQuery} from '@apollo/client';
import {GetAllNpcsQuery} from '../../../../GraphQL/NPCQueries';
import {useAppSelector} from '../../../../redux/hooks';
import {RootState} from '../../../../redux/store';
import {toInteger} from 'lodash';
import Button from '../../../../Atoms/Button';
import {useState} from 'react';
import {PopUp} from '../../../../Atoms/PopUp';
import {AdventureCreateNPCPopUp} from './AdventureCreateNPCPopUp';
import {emptyNPC, NPC} from '../../../../redux/slices/npc/npcType';

export const AdventureNPC = () => {
    const adventure = useAppSelector((state: RootState) => state.adventure);

    const [ isNewNPCDialogVisible, setNewNPCDialogVisible] = useState<boolean>(false);
    const [ chosenNPC, setChosenNPC] = useState<NPC>(emptyNPC);



    const { data: allNpcData, loading: allNpcLoading, error: allNpcError } = useQuery(GetAllNpcsQuery, {
        variables: {
            adventureId: toInteger(adventure.adventureId)
        },
        fetchPolicy: 'network-only'
    });

    const renderOneNPC = (npc: NPC) => {
        return (
            <div className='col-3 row mt-2 abilityContainer' onClick={ () => setChosenNPC(npc) }>
                <div className='col-12'>
                    <b>{npc.npcName}</b>
                </div>
                <div className='col-6'>
                    Level: {npc.npcLevel}
                </div>
            </div>
        )
    }

    const renderAllNPC = () => {
        const html = [];
        if (allNpcData) {
            for (const npc of allNpcData.getNPCs) {
                html.push(renderOneNPC(npc))
            }
        }

        return html;
    }

    return (
        <div>
            { isNewNPCDialogVisible && (
                <AdventureCreateNPCPopUp close={ () => setNewNPCDialogVisible(false) } adventureId={adventure.adventureId}/>
            )}
            <div className='row justify-content-end'>
                <div className="col-3">
                    <Button style={{ width: '40%' }} onClick={ () => setNewNPCDialogVisible(true)}>
                        Neuen NPC erstellen
                    </Button>
                </div>
            </div>
            <div className='npc-container'>
                <div className='row justify-content-evenly'>
                    {renderAllNPC()}
                </div>
            </div>
        </div>
    )
}